import {
  getStoredToken,
  sessionChecker,
  sessionCloser,
} from '../../user/SessionChecker';
import { config } from '../../../config';
import { parseFetchError } from '../../../utils/http';
import { appConfig } from 'config/app';

const home = data => {
  const token = getStoredToken();
  delete data.copyArea;

  if (token) {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          appConfig.api_routes.prefix +
          appConfig.api_routes.modules.ethicalInboxAdmin.prefix +
          appConfig.api_routes.modules.ethicalInboxAdmin.services.home;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser(null);
  }
};

const exportReports = data => {
  const token = getStoredToken();
  if (token) {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          appConfig.api_routes.prefix +
          appConfig.api_routes.modules.ethicalInboxAdmin.prefix +
          appConfig.api_routes.modules.ethicalInboxAdmin.services.export;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/xls',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });

        sessionChecker(res);

        const blob = await res.blob();
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Buzon-Etico.xlsx`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode?.removeChild(link);
        resolve({
          respCode: 0,
          message: 'success',
        });
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser(null);
  }
};

const edit = (id: any) => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          appConfig.api_routes.prefix +
          appConfig.api_routes.modules.ethicalInboxAdmin.prefix +
          appConfig.api_routes.modules.ethicalInboxAdmin.services.view;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({ id }),
        });
        sessionChecker(res);
        const dataOut = await res.json();
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser(null);
  }
};

const sendResponse = data => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          appConfig.api_routes.prefix +
          appConfig.api_routes.modules.ethicalInboxAdmin.prefix +
          appConfig.api_routes.modules.ethicalInboxAdmin.services.response;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        sessionChecker(res);
        const dataOut = await res.json();
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser(null);
  }
};

const deleteReport = data => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          appConfig.api_routes.prefix +
          appConfig.api_routes.modules.ethicalInboxAdmin.prefix +
          appConfig.api_routes.modules.ethicalInboxAdmin.services.delete;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        sessionChecker(res);
        const dataOut = await res.json();
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser(null);
  }
};

export { home, sendResponse, edit, exportReports, deleteReport };
